export { schemaBuilderReview } from "./schemaBuilderReview";
export { schemaDate } from "./schemaDate";
export { schemaDescription } from "./schemaDescription";
export { schemaPlace } from "./schemaPlace";
export { schemaPrice } from "./schemaPrice";
export { schemaPriceRange } from "./schemaPriceRange";
export { schemaType } from "./schemaType";



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/schema/index.ts
// module id = K49P
// module chunks = 2